import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { changePassword } from "action/EmployeeAct";
import { logout } from "service/utilities";
import ChangePassword from "components/Navbar/ChangePassword";

// Shown instead of the app while the user's password was set by someone else
// (new account, admin reset). Closing it logs out.
export default function ForcePasswordChange({ user }) {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);

  const handleChange = (body) => {
    setLoading(true);
    dispatch(changePassword(body)).then(({ success }) => {
      setLoading(false);
      if (success) {
        localStorage.setItem("user", JSON.stringify({ ...user, mustChangePassword: false }));
        window.location.reload();
      }
    });
  };

  return (
    <ChangePassword
      show
      forced
      email={user.email}
      loading={loading}
      onHide={logout}
      handlecallback={handleChange}
    />
  );
}
